import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';



@Component({templateUrl: 'donation.component.html'})
export class DonationComponent implements OnInit  {

    form: FormGroup;
    JSON;
    isgPay_url:string;
    @ViewChild('txnForm') txnForm: any;
    tranxnForm : FormGroup;
    loading = false;
    loadingDropDown = false;
    courseLoader = false;
    categoryLoader = false;
    submitted = false;
    commonUtility:CommonUtility;
    resStatusCode;
    studentName:any ='';
    data:any='';
    res:any;
    dataSource:any;
    feeDetails:any;
    feeId:any ='';
    source:any;
    nationality:any;
    donorName:any;
    mobileNo:any ='';
    initialCap: any;
    emailId:any ='';
    telephoneNo:any='';
    address:any='';
    city:any='';
    zipCode:any='';
    state:any='';
    country:any='';
    donationAmount:any='';
    pan:any='';
    remark:any='';
    idNumber:any='';
    EncDataField:string;
    MerchantIdField:string;
    TransactionId:string;
    BankIdField:string;
    TerminalIdField:string;
    VersionField:string;
    dob:any;
    captcha:any;
    todayDate:Date;
    myDIV: Boolean = false ;
    @ViewChild('submitButton') submitButton;

   constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService
  )
  {
    this.JSON=JSON;
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;
  }

ngOnInit(): void {
  this.todayDate = new Date();
  this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:['']

         });
  this.form = this.formBuilder.group({

    donorName:["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")],],
    nationality:["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
    mobileNo:["",[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]],
    emailId:["",Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")],
    telephoneNo:["",Validators.pattern("^[0-9-]+$")],
    address:["",[Validators.required]],
    city:["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
    zipCode:["",Validators.pattern("^[1-9]\\d{5}$")],
    state:["",Validators.pattern("^[a-zA-Z ]+$")],
    country:["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
    pan:["",Validators.pattern("[A-Z]{5}[0-9]{4}[A-Z]{1}$")],
    donationAmount:["",[Validators.required,Validators.pattern("^[0-9.]+$")]],
    remark:[""],
    captcha: ["", [Validators.required]]



  });
  this.Cap();

}
get f()
 { return this.form.controls; }


 

 Submit() {
  console.log(this.form);
  console.log(this.form.invalid);
  var routeUrl;
  this.submitted = true;



   if(this.form.controls.donationAmount.value == 0)
    {
      this.commonUtility.alertMsg('Donation Amount Should Not be Zero , Please Enter the Donation Amount','',false);
    }
    

    else{
      if (this.form.invalid || (!this.ValidCaptcha()) ) {
      return;
    }


const encodedCaptcha = btoa(this.form.controls.captcha.value);
  let req = {
    'donorName': this.form.controls.donorName.value,
    'nationality': this.form.controls.nationality.value,
    'address': this.form.controls.address.value,
    'city': this.form.controls.city.value,
    'state': this.form.controls.state.value,
    'pincode': this.form.controls.zipCode.value,
    'mobileNo': this.form.controls.mobileNo.value,
    'country': this.form.controls.country.value,
    'source': 'ISKCON',
    'donationAmount': this.form.controls.donationAmount.value,
    'pan': this.form.controls.pan.value,
    'remark': this.form.controls.remark.value,
    'emailId': this.form.controls.emailId.value,
    'telephoneNo': this.form.controls.telephoneNo.value,
    "captcha":this.form.controls.captcha.value
  }

console.log("req : ");
console.log(req);

 this.categoryService.initiateDonationPayment(req,encodedCaptcha).subscribe(res =>  {
  if(res.body.statusCode === "00000")
  {
   //console.log(" res : "+JSON.stringify(res))
   //this.commonUtility.alertMsg('Submitted Successfully ','',true);
   this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
   this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
   this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
   this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
   this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
   this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

   this.EncDataField  	= res.body.data.fields.EncData;
   this.MerchantIdField = res.body.data.fields.MerchantId;
   this.BankIdField = res.body.data.fields.BankId;
   this.TerminalIdField = res.body.data.fields.TerminalId ;
   this.VersionField = res.body.data.fields.Version ;
   this.txnForm.nativeElement.submit();


  }
  else{
  // this.commonUtility.alertMsg('Please try again Failed to submit data'+res.body.statusDesc,'',false);
  this.commonUtility.alertMsg('Please try again. Failed to submit the data. Pan Number is Mandatory','',false);
  }
   this.loading = false;
        }
  )
 }
}

     formInit():void{
    }


  //  onSubmit() {
  //    this.submitted = true;
//
  //    // reset alerts on submit
  //    // this.alertService.clear();
  //    // stop here if form is invalid
  //    if (this.form.invalid) {
  //        return;
  //    }
  //    this.loading = true;
//
  //    var req={
  //        "studentId":this.studentData.studentId.toString(),
  //        "emailId":this.form.controls.emailId.value,
  //        "mobileNo":this.form.controls.mobileNo.value.toString(),
  //        "registrationNo" :  this.studentData.registrationNo.toString(),
  //        "status" : this.feeData.status.toString()
  //    }
//
  //    this.paymentService.updateStudentDetail(req).subscribe(res=>{
//
  //  //console.log("res "+JSON.stringify(res));
  //   if(res.body.statusCode === "00000")
  //   {
  //    //console.log(" res : "+JSON.stringify(res))
  //    //this.commonUtility.alertMsg('Submitted Successfully ','',true);
  //    this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
  //    this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
  //    this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
  //    this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
  //    this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
  //    this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);
//
  //    this.EncDataField  	= res.body.data.fields.EncData;
  //    this.MerchantIdField = res.body.data.fields.MerchantId;
  //    this.BankIdField = res.body.data.fields.BankId;
  //    this.TerminalIdField = res.body.data.fields.TerminalId ;
  //    this.VersionField = res.body.data.fields.Version ;
  //    this.txnForm.nativeElement.submit();
//
//
  //   }
  //   else{
  //    this.commonUtility.alertMsg('Please try again Failed to submit data'+res.body.statusDesc,'',false);
  //   }
  //    this.loading = false;
  //  },
  //  (error)=>{
//
  //    this.commonUtility.alertMsg('Please try again Failed to submit data','',false);
  //      //this.router.navigate([''])
  //      this.loading = false;
  //    });
//
  //}

onSubmit(): void
{

}

onSubmitVisible():boolean{

  let donorName = (this.form.get('donorName').value === "") || (this.form.get('donorName').value === null) || (this.form.get('donorName').value === undefined);
  let nationality = (this.form.get('nationality').value === "") || (this.form.get('nationality').value === null) || (this.form.get('nationality').value === undefined);
  let address = (this.form.get('address').value === "") || (this.form.get('address').value === null) || (this.form.get('address').value === undefined);
  let city = (this.form.get('city').value === "") || (this.form.get('city').value === null) || (this.form.get('city').value === undefined);
  let state =  (this.form.get('state').value === "") || (this.form.get('state').value === null) || (this.form.get('state').value === undefined);
  let zipCode =  (this.form.get('zipCode').value === "") || (this.form.get('zipCode').value === null) || (this.form.get('zipCode').value === undefined);
  let donationAmount = (this.form.get('donationAmount').value === "") || (this.form.get('donationAmount').value === null) || (this.form.get('donationAmount').value === undefined);
  let pan = (this.form.get('pan').value === "") || (this.form.get('pan').value === null) || (this.form.get('pan').value === undefined);
  let emailId = (this.form.get('emailId').value === "") || (this.form.get('emailId').value === null) || (this.form.get('emailId').value === undefined);
  let mobileNo = (this.form.get('mobileNo').value === "") || (this.form.get('mobileNo').value === null) || (this.form.get('mobileNo').value === undefined);


  if(donorName || nationality || address || city || state|| zipCode|| donationAmount || pan || address || emailId || mobileNo)
  {
  return true;
  }
  else
  {
  return false;
  }
  }
  redirectHome()
  {
    //this.router.navigate(['/']);
    window.location.reload();
  }

  ValidCaptcha(){
    let str1=this.initialCap
    let str2=this.form.get('captcha').value;
    if(str2.toUpperCase()!="") {
    if(str1 == str2.toUpperCase()){
      this.form.controls['captcha'].setErrors(null);
      return true;
    }else{
      this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
      return false;
    }
    }
    else {
      this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
    }
  }

  Cap() {
    let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
     var apl1 = alpha[Math.floor(Math.random() * 36)];
     var apl2 = alpha[Math.floor(Math.random() * 36)];
     var apl3 = alpha[Math.floor(Math.random() * 36)];
     var apl4 = alpha[Math.floor(Math.random() * 36)];
     var apl5 = alpha[Math.floor(Math.random() * 36)];
     var apl6 = alpha[Math.floor(Math.random() * 36)];
     this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;

    }

}
